import React, { useCallback, useEffect, useState, memo } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, Step, StepLabel, Stepper } from '@mui/material';
import { EnhancedRoute } from '../EnhancedRoute';
import './steps.css';
import { styled } from '@mui/system';

export type StepsArray = { path: string; screen: Function; step: number; label: string }[];

type IntroMessagesSliderProps = {
    open: boolean;
    steps: StepsArray;
    skipSteps: number[];
    infoSteper?: boolean;
};

const IntroMessagesSlider = (props: IntroMessagesSliderProps) => {
    const { open, steps, skipSteps, infoSteper} = props;
    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = React.useState<{
        [k: number]: boolean;
    }>({});

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const firstStepPath = steps[0].path;
        navigate(firstStepPath);
    }, []);

    const getCurrentStep = useCallback(() => {
        if (location.pathname && steps.length) {
            const step = steps.find((item) => item.path === location.pathname);
            return step ? step.step : 0;
        }
    }, [location.pathname, steps])

    const findActiveStep = useCallback(() => {
        const stepIndex = getCurrentStep() ?? 0;
        const skipedStepBefore = skipSteps.filter(x => x < stepIndex).length;
        return stepIndex - skipedStepBefore;
    }, [location.pathname, steps, getCurrentStep]);

    const setCompletedSteps  = useCallback(() => {
        const stepIndex = getCurrentStep() ?? 0;
        const newCompleted : {[k: number]: boolean;} = {};
        steps.map(step => {
            if(step.step < stepIndex &&  skipSteps.indexOf(step.step) == -1){
                newCompleted[step.step] = true;
            }
        });
        setCompleted(newCompleted);
    }, [location.pathname, steps]);

    useEffect(() => {
        const step = findActiveStep() || 0;
        setActiveStep(step);
        setCompletedSteps()
    }, [location, findActiveStep, setCompletedSteps]);

    const renderRoutes = (steps: { path: string; screen: Function }[]) => {
        return (
            <>
                {steps.map((step, index) => (
                    <Route
                        key={index}
                        path={step.path}
                        element={
                            <EnhancedRoute
                                steps={steps}
                                index={index}
                                Element={step.screen}
                                skipSteps={skipSteps}
                            />
                        }
                    />
                ))}
            </>
        );
    };

    let rowNo= 0;
    const getRowNo = () =>{
        rowNo = rowNo + 1;
        return rowNo;
    };

    const CardSection = styled('div')({
        transition: '0.3s',
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        rowGap: 15,
    });

    return (
        <Dialog open={open} fullWidth maxWidth="md" disableEnforceFocus={true} scroll={'paper'} >
            <CardSection>
                <DialogTitle>
                    <Stepper nonLinear activeStep={activeStep} alternativeLabel className="stepper">
                        {steps.map((label, index) => (
                            skipSteps.indexOf(index) == -1 &&
                            <Step key={index} completed={completed[index]}>
                                <StepLabel icon={infoSteper ? 'i' : getRowNo()} />
                            </Step>

                        ))}
                    </Stepper>
                </DialogTitle>
                <DialogContent>
                    <Routes>{renderRoutes(steps)}</Routes>
                </DialogContent>
            </CardSection>
        </Dialog>
    );
};

export default IntroMessagesSlider;
